import $ from 'jquery';
(window as any).$ = $;
(window as any).jQuery = $;

import 'jquery-validation';

import Global from './common/global';
import { SheetHelper } from './common/sheetHelper';
import { showSnackbar } from './common/snackBar';
import { CustomerFavouriteManager } from './common/customerFavouriteManager';
import { ButtonHelper } from './common/buttonHelper';
import { initGlobalValidationHandlers } from './common/validationHelper';
import { setValidationMessages } from './common/validationHelper';

import { TransferHelper } from './common/transferHelper';

document.addEventListener('DOMContentLoaded', () => {
    
    Global.updateFooterLinkGrid('.db-footer-links-cms');
    ButtonHelper.initSpinnerButtons();
    Global.initCounters();
    //Global.initGlobalModalTriggers();
    //Global.initGlobalModalClose();

    // Re-check on scroll of body or window
    $('body').on('scroll', () => {
        Global.checkLazyImages();
    });

    $(window).on('scroll', () => {
        Global.checkLazyImages();
    });

    // Re-check on window resize
    $(window).on('resize', () => {
        Global.checkLazyImages();
        Global.updateFooterLinkGrid('.db-footer-links-cms');
    });

    // Show snack bar message if one is set in tempData
    showSnackbar();

    // Initialize customer favourite manager
    CustomerFavouriteManager.init();

    // Initialize any swipers
    Global.initHotelListSwiper();
    Global.initTabsSwiper();
    Global.initThemeHotelSwipers();
    Global.initLocationListSwiper();
    Global.initRecentPostsSwiper();

    // Sheets
    SheetHelper.initCloseButtons();

    // Global Validation
    const culture = (window as any).siteCulture || 'en';

    initGlobalValidationHandlers();

    setValidationMessages(culture);

    if (document.querySelector('.transfer-mode-container')) {
        TransferHelper.initCallCentreTransferMode();
    }

    // Initial lazy load check
    Global.checkLazyImages();
});